import { router } from './router';

const app = document.getElementById('app');
if (!app) throw new Error('App container not found');

// Initialize router
router.init(app);
